import {padStart} from "lodash";
import * as Sentry from "@sentry/browser";

export function format_number_surgeries(value)  {
    const null_value = '-';
    if (value === undefined || value === null) {
        return null_value;
    }
    if (typeof value === "string") {
        const parsed = parseInt(value);
        if (!isNaN(parsed)) {
            value = parsed;
        }
    }
    if (typeof value === "number") {
        return value !== 0 ? value.toString() : '-';
    } else {
        return null_value;
    }
}

export function generate_table_field(element, translation_function) {
    if (element.hasOwnProperty('translation_key')) {
        const translated_tag = translation_function(element.translation_key);
        delete element.translation_key;
        return {label: translated_tag, ...element};
    }
    return element;
}


export function yesNoNullFilter(boolean_value, i18n) {
    if (boolean_value === null) {
        return '-';
    }
    return i18n.t(yesNoFilter(boolean_value));
}

/**
 * Create a filter to convert values to yes/no string for I18n
 * @param boolean_value
 * @return {string}
 */
export function yesNoFilter(boolean_value) {
    if (boolean_value === null) {
        boolean_value = false;
    }
    if (typeof boolean_value === "string") {
        if (boolean_value === '-') {
            return '';
        }
        if (boolean_value.toLowerCase() === 'true') {
            boolean_value = true;
        } else if (boolean_value.toLowerCase() === 'false') {
            boolean_value = false;
        } else {
            throw Error('Cannot convert ' + boolean_value + ' to a boolean value yes/no');
        }
    }

    if (typeof boolean_value === "object") {
        boolean_value = true;
    }
    return boolean_value ? 'utils.yes' : 'utils.no';
}

export const YES_NO_SELECT = [{value: true, text: 'utils.yes'}, {value: false, text: 'utils.no'}];

export function capitalizeFilter(word) {
    if (word === undefined || typeof word !== 'string') {
        throw Error('The value ' + word + ' is not a string');
    }
    return word.charAt(0).toUpperCase() + word.substring(1);
}

export function isNull(js_object) {
    return js_object === undefined || js_object === null;
}

export function nullableString(string, empty = "-") {
    if (!isNull(string) && string !== "") {
        return string;
    }
    return empty;
}

export function nullableNumber(number) {
    if (isNaN(number) || isNull(number)) { return '-'; }
    return number;
}

export function fieldToChoices(fieldArray, textField = 'display_name', valueField = 'value') {
    return fieldArray.map(value => {
        return {text: value[textField], value: value[valueField]};
    });
}

export function displayChoice(value, field) {
    if (field.hasOwnProperty('choices')) {
        const found = field.choices.find(element => element.value === value);
        return found !== undefined ? found.display_name : '';
    } else {
        throw 'Field ' + field.label + ' has no property choices';
    }
}

export function padNumber(number, length, padString = '0') {
    if (length === undefined) { Sentry.captureMessage('You must supply length to padNumber'); }
    let str = number.toString();
    if (str === '') {
        return '';
    }
    return padStart(str, length, padString);
}


export function formatDate(value, {format = 'date', showDay = true}) {
    if (isNull(value) || value === '') { return ''; }
    const date = new Date(value);
    let options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    };

    if (showDay) { options.weekday = 'long'; }

    if (format === 'datetime') {
        options['hour'] = '2-digit';
        options['minute'] = '2-digit';
    }
    if (format === 'time') {
        options = {
            hour: '2-digit',
            minute: '2-digit'
        };
    }

    return capitalizeFilter(date.toLocaleString('es', options));
}


export function extractDate(dateString) {
    return dateString.split('T')[0];
}
